
import BaseModel from "./base.model";
import { enuAvanzamento } from "./enuAvanzamento";
import { enuRitiroSpedizioneDeposito } from "./enuRitiroSpedizioneDeposito";

export class MovimentoDTO extends BaseModel{
    get isLingotto():boolean{
        return this.idLingotto!="" && this.idLingotto!=null;
    }
    get isPAO():boolean{
        return this.idPAO!="" && this.idPAO!=null;
    }
    created_at?:Date;
    dataNextBuy?:Date;
    updated_at?:Date;
    date?:Date;
    gr?:number;
    grAcquistati:number = 0;
    grammiProdotto:number = 0;
    id:string = "";
    userId:string = "";
    username:string = "";
    idPAO:string = "";
    urlfattura:string = "";
    urlfatturarivendita:string = "";
    idLingotto:string = "";
    iddeposito:string = "";
    isAwaitBuy:boolean = false;
    note:string = "";
    perc:number = 0;
    prezzo:number = 0;
    description:string = "";
    ratetotali?:number = 0;
    rivalutazione:number = 0;   
    stato:string = "";
    avanzamento:enuAvanzamento =0;
    ritiroSpedizioneDeposito:enuRitiroSpedizioneDeposito = 0;
    indirizzo?:string;
    rataIsPayed:boolean = false;
    dataPagamento?:Date;
    idBonificoPagamento?:string;
    numeroFattura?:string;
    dataSpedizione?:Date;
    trackingNumber?:string;
    vettore?:string;
    dataRitiro?:Date;
    operatoreRitiro?:string;
    serialeLingotto?:string;
    nominativoProprietario?:string;
    importoRataPao?:number;
    prezzoTotale?:number;
    initialpricegr?:number;
    importoPagato?:number;
    numeroDeposito?:string;
    costocomplessivo?:number;
    costoriscatto?:number;
    dataPagamentoSpeseRiscatto?:Date;
    idBonificoSpeseRiscatto?:string
    costorivendita?:number;
    dataPagamentoRivendita?:Date;
    idBonificoRivendita?:string
    
}

